import { TextChatCapabilities } from "../../../components/TextChat/TextChat.types";
import { GlobalChatMessage } from "./globalChatCache";
import { canReplyToGlobalChatMessage } from "./globalChatComposition";

export type GlobalChatMessageActionAvailability = {
  reply: boolean;
  copy: boolean;
  react: boolean;
  edit: boolean;
  delete: boolean;
  pin: boolean;
  unpin: boolean;
  retry: boolean;
  discard: boolean;
};

export const getVisibleMessageText = (message: GlobalChatMessage) =>
  message.text?.trim() || "";

export const getGlobalChatMessageActionAvailability = ({
  message,
  currentUserId,
  capabilities,
  canWrite,
  isPinned = false,
}: {
  message: GlobalChatMessage;
  currentUserId?: string;
  capabilities: Pick<TextChatCapabilities, "reactions">;
  canWrite: boolean;
  isPinned?: boolean;
}): GlobalChatMessageActionAvailability => {
  const isSystem = message.user === "System";
  const isCurrentUser =
    Boolean(currentUserId) &&
    message.user !== "System" &&
    message.user?._id === currentUserId;
  const isLocalOnly = Boolean(message.isLocalOnly);
  const isFailedLocal = isLocalOnly && message.deliveryState === "failed";
  const isUnavailableLocal =
    isLocalOnly ||
    message.deliveryState === "pending" ||
    message.deliveryState === "queued" ||
    message.deliveryState === "retrying" ||
    message.deliveryState === "failed";
  const isBooking = Boolean(message.realTimeBooking);
  const isDeleted = Boolean(message.deletedAt);
  const hasText = getVisibleMessageText(message).length > 0;
  const isOrdinary = !isSystem && !isBooking && !isDeleted;
  const canUseServerActions = isOrdinary && !isUnavailableLocal;

  return {
    reply: canReplyToGlobalChatMessage(message),
    copy: hasText,
    react: Boolean(capabilities.reactions) && canUseServerActions,
    edit:
      canWrite &&
      isCurrentUser &&
      canUseServerActions &&
      !message.voice &&
      hasText,
    delete: canWrite && isCurrentUser && canUseServerActions,
    pin: canWrite && canUseServerActions && !isPinned,
    unpin: canWrite && canUseServerActions && isPinned,
    retry: isFailedLocal,
    discard: isFailedLocal,
  };
};
